import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { pmsFrom } from '@/integrations/pms';
import ServiceCategoryPage from '@/pages/ServiceCategoryPage';
import ServiceRegionPage from '@/pages/ServiceRegionPage';
import { Loader2 } from 'lucide-react';

/**
 * Resolves /:a/:b — could be /:segSlug/:catSlug OR /:industrySlug/:regionSlug.
 * Checks if first param matches a service segment; if not, treats as industry/region.
 */
const TwoSegmentResolver: React.FC = () => {
  const params = useParams<{ a: string; b: string }>();
  const firstParam = params.a || '';

  const { data: isSegment, isLoading } = useQuery({
    queryKey: ['resolve-segment', firstParam],
    queryFn: async () => {
      const { data } = await pmsFrom('service_segments')
        .select('id')
        .eq('slug', firstParam)
        .eq('is_active', true)
        .maybeSingle();
      return !!data;
    },
    staleTime: Infinity,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isSegment) {
    return <ServiceCategoryPage />;
  }

  return <ServiceRegionPage />;
};

export default TwoSegmentResolver;
